import { EnumFilter } from "@/components/data-table/components/EnumFilter";
import { BOOLEAN_VALUES, PATH_USER } from "@/constants";
import { DisplayAvailableEmailRecipient } from "@/types/emailRecipient";
import { Row } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

export const useEmailRecipientsAvailableColumnOverrides = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      full_name: {
        id: "full_name",
        meta: {
          externalPath: (row: DisplayAvailableEmailRecipient) =>
            generatePath(PATH_USER, { userId: row.id }),
        },
      },
      status: {
        id: "status",
        meta: {
          filter: {
            component: EnumFilter,
            props: {
              options: BOOLEAN_VALUES,
              translationKey: "activeValues",
            },
          },
        },
        cell: ({ row }: { row: Row<DisplayAvailableEmailRecipient> }) =>
          row.original.status
            ? t("users.status.active")
            : t("users.status.inactive"),
      },
    }),
    [t],
  );
};
